export default __webpack_public_path__ + "static/media/kint-felirat.c5389a27.png";